import { render, staticRenderFns } from "./RevenueExpensesContract.vue?vue&type=template&id=b883686a&scoped=true"
import script from "./RevenueExpensesContract.vue?vue&type=script&lang=js"
export * from "./RevenueExpensesContract.vue?vue&type=script&lang=js"
import style0 from "./RevenueExpensesContract.vue?vue&type=style&index=0&id=b883686a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b883686a",
  null
  
)

export default component.exports